export default "__VITE_ASSET__B5aOkq7B__"